module.exports = __webpack_public_path__ + "static/media/added-image.bbe47a50.png";